// extracted by mini-css-extract-plugin
export default {"wrapper":"DeleteMiner_wrapper__DHYFl","content":"DeleteMiner_content__MBGl8","btn_wrapper":"DeleteMiner_btn_wrapper__z8DUQ"};